import { useQuery } from "react-query";
import { getCustomPlaylists } from "@/api";
import { useUser } from "@/providers/context";
import { useAppProperties } from "@/hooks/useAppProperties.tsx";
import { useMemo } from "react";

export const usePlaylists = () => {
  const { uid } = useUser();
  const { showCustomPlaylists } = useAppProperties();
  const query = useQuery(
    ["playlists", uid],
    () => {
      if (uid) {
        return getCustomPlaylists({ user_id: uid });
      }
    },
    {
      enabled: showCustomPlaylists,
    },
  );

  const data = useMemo(() => {
    if (!query.data) {
      return query?.data;
    }
    const playlists = query?.data?.Playlists.sort(
      (a, b) => a.Position - b.Position,
    );
    return { ...query.data, Playlists: playlists };
  }, [query.data]);

  return { ...query, data };
};
